import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-mist border-y border-mist-dark" data-id="element-82" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-83" data-mp="bibgqof5ud4n">
        <div className="text-center mb-16" data-id="element-84" data-mp="gbwecfcud53b">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-85" data-mp="gcxnufe7ljix">
            ⭐ What Wrestling Coaches Want From a Complete System
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-86" data-mp="q7ha3vrbh94m">
          {extendedTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-mist-dark p-8 rounded-2xl relative shadow-sm flex flex-col" data-id="element-87" data-mp="u8t56gsymmk7" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-gold/25" size={48} data-id="element-88" data-mp="380o6ud6zlgif" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-89" data-mp="37yl7h2jy2b11">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-90" data-mp="2z0j1e8lcss6w" data-mpi={starIndex} />)}
              </div>
              <p className="text-slate italic mb-8 relative z-10 leading-relaxed" data-id="element-91" data-mp="3voyxyomvs1ti">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-92" data-mp="3rmau6vd0xl3e">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-93" data-mp="3mo0tk58j5sae">
                  {testimonial.initials}
                </div>
                <div data-id="element-94" data-mp="2baycza6fl2q8">
                  <div className="font-bold text-navy" data-id="element-95" data-mp="2bbggmrvfaj86">{testimonial.name}</div>
                  <div className="text-xs text-azure" data-id="element-96" data-mp="26aamcpm46nwj">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
        <p className="text-center text-[11px] text-slate mt-8" data-id="element-97" data-mp="2crkle4lzjxa6">
          Replace testimonial-style copy with verified customer feedback before publishing.
        </p>
      </div>
    </section>;
}